export const SEARCH_BAR_DEBOUNCE_MS = 1000;